
import React, {Component, PropTypes} from 'react';
import classNames from 'classnames';

import Button from './Button';

class Toast extends Component{
    static propTypes = {
        toast: PropTypes.string.isRequired,
        rounded: PropTypes.bool,
        onClick: PropTypes.func,
        children: PropTypes.node,
        className: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this, props.onClick);
    }

    onClick(onClick) {
        // eslint-disable-next-line no-undef
        Materialize.toast(this.props.toast, 1500);
        if (onClick) {
            onClick();
        }
    }

    render() {
        let classes = {
            rounded: this.props.rounded
        };

        let {className, children, onClick, ...props} = this.props;

        return (
            <Button onClick={this.onClick} className={classNames(classes, className)} {...props}>
                {children}
            </Button>
        );
    }
}
export default Toast;
